import {PRODUCTION} from '../config';

export const getAssetsPrefix = (assetPath: string) => {
  return 'https://' + ((PRODUCTION ? 'prod' : 'dev') + `-hub-ui-content.s3.eu-central-1.amazonaws.com/airdrop/${assetPath}`).replace(/\/\//gm, '/');
};